// Module
var code = "<select class=\"form-control input-sm\" style=\"margin-top:-2px;margin-bottom:-2px\" ng-change=\"vm.update()\" ng-disabled=\"vm.isDisabled || vm.properties.length < 2\" ng-model=\"vm.seriesValue\" ng-options=\"property.key as property.value | translate for property in vm.properties\"> </select>";
// Exports
module.exports = code;